import { formatarDataHora } from "../../../utils/solicitacoes/formatters";

export default function ComentarioList({ itens = [] }) {
    const comentarios = itens
        .filter(i => i.tipo === "COMENTARIO")
        .sort((a, b) => new Date(a.dataHora) - new Date(b.dataHora));

    if (comentarios.length === 0) {
        return <p className="text-sm text-muted-foreground text-center py-4">Nenhum comentário ainda.</p>;
    }

    return (
        <div className="flex flex-col gap-3 max-h-80 overflow-y-auto pr-1">
            {comentarios.map((c, idx) => (
                <div key={idx} className="bg-muted rounded-lg rounded-tl-none p-3">
                    <div className="flex items-center justify-between gap-2 mb-1">
                        <span className="text-xs font-semibold text-foreground">{c.usuarioNome}</span>
                        <span className="text-[10px] text-muted-foreground">{formatarDataHora(c.dataHora)}</span>
                    </div>
                    <p className="text-sm text-foreground break-words">{c.conteudo}</p>
                </div>
            ))}
        </div>
    );
}
